
import { useState, useEffect } from "react";
import { optimizeImage } from "../utils/imageOptimizer";

export const useOptimizedMedia = (src, width, height) => {
  const [optimizedSrc, setOptimizedSrc] = useState(src);

  useEffect(() => {
    const fetchOptimizedImage = () => {
      const optimized = optimizeImage(src, width, height);
      setOptimizedSrc(optimized);
    };

    fetchOptimizedImage();
  }, [src, width, height]);

  return optimizedSrc;
};
